import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsMyTurn, selectMyPlayer, selectCardsInTable, changeTableCards, selectCardPileCount } from '../../redux/gameSlice';
import { selectIsCurrentlyShuffling } from '../../redux/animationSlice';
import Card from './Card';
import { setOverlayBuyingCard } from '../../redux/overlaySlice';
import cards from '../../cardList';
import { isPlayerBusinessMan } from '../../playerUtils';
import { Trans } from '@lingui/macro';

export default function TableCards(props) {
  const isMyTurn = useSelector(selectIsMyTurn);
  const myPlayer = useSelector(selectMyPlayer);
  const cardsInTable = useSelector(selectCardsInTable);
  const cardCount = useSelector(selectCardPileCount);
  const canSwapCards = myPlayer.energy >= 2 && isMyTurn;
  const dispatch = useDispatch();
  const currentlyShuffling = useSelector(selectIsCurrentlyShuffling);

  const swapCards = useCallback(() => {
    if (!canSwapCards) {
      return;
    }

    dispatch(changeTableCards());
  }, [dispatch, canSwapCards]);

  let cardList = [];
  const costDiscount = isPlayerBusinessMan(myPlayer) ? 1 : 0;
  for (let cardIdx in cardsInTable) {
    if (!cards[cardsInTable[cardIdx]]) {
      console.error(`Can't find card by index: ${cardIdx} (card type: ${cardsInTable[cardIdx]})!`);
      continue;
    }

    let canAfford = myPlayer.energy >= (cards[cardsInTable[cardIdx]].cost - costDiscount);
    cardList.push(<Card type={cardsInTable[cardIdx]} key={cardIdx} canAfford={canAfford} costDiscount={costDiscount} onClick={() => dispatch(setOverlayBuyingCard(cardIdx))} />);
  }

  if (cardList.length === 0) {
    return <div id="cards-on-table-container" className="empty-deck">
      <div id="cards-on-table">
        <p><Trans>
          No more cards left
        </Trans></p>
      </div>
    </div>
  }

  return <div id="cards-on-table-container">
    <div className="center-structure" >
      <div id="cards-on-table-title">
        <div className="spec-header">
          <p className="content-title"><Trans>
            Cards on the table ({cardCount - cardsInTable.length} left in the pile)
          </Trans></p>
          <p className="content-explanation"><Trans>
            Click any card to buy it, or swap all of them at the cost of 2 Energy.
          </Trans></p>
        </div>
      </div>
    </div>
    <div id="cards-on-table-wrap">
      <div id="swap-cards-container" className={cardCount < 3 ? 'hidden' : ''}>
        <button type="submit" className="button" id="swap-cards-button" disabled={canSwapCards === false} onClick={swapCards}>
          <span className="tooltip-wrap" aligned="left">
            <span className="tooltip">
              <Trans>
                Swap the 3 cards that are currently on the table for new ones
              </Trans>
            </span>
          </span>
          <span className="button-content-fixed-width"><i className="fas fa-sync-alt"></i></span>
        </button>
        <div id="swap-energy-cost-line">
          <span className={`swap-energy-cost ${myPlayer.energy < 2 ? 'energy-cost-expensive' : ''}`}>2</span>
          <span className="swap-energy-cost-icon"></span>
        </div>
      </div>
      <div id="cards-on-table" className={currentlyShuffling ? 'hidden' : ''}>
        {cardList}
      </div>
    </div>
  </div>
};
